import { Navigation } from '../components/Navigation';
import { Hero } from '../components/Hero';
import { Positioning } from '../components/Positioning';
import { HowWeWork } from '../components/HowWeWork';
import { RetainerModel } from '../components/RetainerModel';
import { WhoThisIsFor } from '../components/WhoThisIsFor';
import { About } from '../components/About';
import { FinalCTA } from '../components/FinalCTA';
import { Footer } from '../components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50" data-testid="home-page">
      <Navigation />
      <Hero />
      <Positioning />
      <HowWeWork />
      <RetainerModel />
      <WhoThisIsFor />
      <About />
      <FinalCTA />
      <Footer />
    </div>
  );
}
